<template>
  <div
    v-if="isModerator"
    class="hc-controls"
  >
    <Copy
      name="copy_icon"
      class="hc-copy"
      @click.stop="copyLink"
    />
    <a
      :href="`/admin/help_center/question/${questionId}/change/`"
      target="_blank"
    >
      <Edit
        name="edit_icon"
        class="hc-edit"
      />
    </a>
    <UiToast
      :open="toastOpen"
      @close="toastClose"
    >
      <template #content>
        <Check />
        <span>Скопировано</span>
      </template>
    </UiToast>
  </div>
</template>

<script setup lang="ts">
  import { useUserStore } from '@/entities/user';
  import Check from '@/shared/ui/icons/Check.vue';
  import Copy from '@/shared/ui/icons/Copy.vue';
  import Edit from '@/shared/ui/icons/Edit.vue';
  import { UiToast } from '@experience/core-toast-ui';

  interface IProps {
    questionId: number;
  }
  const props = defineProps<IProps>();

  const userStore = useUserStore();

  const isModerator = computed(() => userStore.isModerator);
  const toastOpen = ref(false);

  const copyLink = () => {
    const link = `${window.location.origin}${window.location.pathname}#${props.questionId}`;
    navigator.clipboard.writeText(link);
    toastOpen.value = true;
  };

  const toastClose = () => {
    toastOpen.value = false;
  };
</script>

<style lang="scss" scoped>
  .hc-controls {
    display: flex;
    gap: 8px;

    a {
      display: flex;
    }
  }

  .hc-copy {
    cursor: pointer;
  }
</style>
